import { render, staticRenderFns } from "./add-condition-detail.vue?vue&type=template&id=f820cd60&scoped=true&"
import script from "./add-condition-detail.vue?vue&type=script&lang=js&"
export * from "./add-condition-detail.vue?vue&type=script&lang=js&"
import style0 from "./add-condition-detail.vue?vue&type=style&index=0&id=f820cd60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f820cd60",
  null
  
)

export default component.exports